module.exports = __webpack_public_path__ + "../public/img/Qr_passo_1.aa8be3c3.png";